<template>
  <div class="content">
    <EsForm>
      <template #es-form>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Name</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input
                v-model="name"
                class="input"
                :class="{ 'is-danger': hasErrorName }"
                type="text"
                placeholder="Enter Name"
                v-on:keydown.enter.prevent="formValidation"
                maxlength="200">
              <p class="help is-danger">{{ nameMsg }}</p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Street 1</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input
                v-model="street1"
                class="input"
                :class="{ 'is-danger': hasErrorStreet1 }"
                type="text"
                placeholder="Enter Street 1"
                v-on:keydown.enter.prevent="formValidation"
                maxlength="100">
              <p class="help is-danger">{{ street1Msg }}</p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Street 2</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input
                v-model="street2"
                class="input"
                :class="{ 'is-danger': hasErrorStreet2 }"
                type="text"
                placeholder="Enter Street 2"
                v-on:keydown.enter.prevent="formValidation"
                maxlength="100">
              <p class="help is-danger">{{ street2Msg }}</p>
            </div>
          </div>
        </div>


        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">City</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input
                v-model="city"
                class="input"
                :class="{ 'is-danger': hasErrorCity }"
                type="text"
                placeholder="Enter City"
                v-on:keydown.enter.prevent="formValidation"
                maxlength="40">
              <p class="help is-danger">{{ cityMsg }}</p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">State</label>
          </div>
          <div class="field-body">
            <div class="field is-narrow">
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="state">
                    <option value="" disabled hidden>Select State</option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Zip</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input
                v-model="zip"
                class="input"
                :class="{ 'is-danger': hasErrorZip }"
                type="text"
                placeholder="Enter Zip"
                v-on:keydown.enter.prevent="formValidation"
                maxlength="10">
              <p class="help is-danger">{{ zipMsg }}</p>
            </div>
          </div>
        </div>
      </template>
    </EsForm>
    <es-form>
      <template #es-form>
        <div class="field is-grouped flex-justify--end">
          <div class="control is-flex flex-align--center">
            <a @click="resetForm">Reset</a>
          </div>
          <div class="control">
            <button
              class="button is-primary"
              @click.stop.prevent="formValidation"
              :disabled="loading"
            >
              Search
            </button>
          </div>
        </div>
      </template>
    </es-form>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';

library.add(faTimes);

export default {
  mixins: [BreadcrumbsManager],
  components: {
    EsForm,
    EsFormActions,
  },
  props: {
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      name: null,
      street1: null,
      street2: null,
      city: null,
      state: 'LA',
      zip: null,
      searchSource: 'advancedSearch',
      nameMsg: null,
      street1Msg: null,
      street2Msg: null,
      cityMsg: null,
      stateMsg: null,
      zipMsg: null,
      hasErrorName: false,
      hasErrorStreet1: false,
      hasErrorStreet2: false,
      hasErrorCity: false,
      hasErrorState: false,
      hasErrorZip: false,
    };
  },
  created() {
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'groupList' } },
      { text: 'Search Options', to: { } },
    ]);
    this.checkQuery();
  },
  methods: {
    checkQuery() {
      const { query } = this.$route;

      if (query.searchSource) {
        this.searchSource = query.searchSource;
        this.name = query.name;
        this.street1 = query.street1;
        this.street2 = query.street2;
        this.city = query.city;
        this.state = 'LA';
        this.zip = query.zip;
      }
    },
    search() {
      const { query } = this.$route;

      if (
        query.name === this.name
        && query.city === this.city
        && query.street1 === this.street1
        && query.street2 === this.street2
        && query.state === this.state
        && query.zip === this.zip
      ) {
        return;
      }

      this.$router.push(
        {
          name: 'advancedSearch',
          query: {
            searchSource: this.searchSource,
            name: this.name,
            street1: this.street1,
            street2: this.street2,
            city: this.city,
            state: this.state,
            zip: this.zip,
          },
        },
      );
    },
    formValidation() {
      this.resetErrors();
      let errors = 0;

      if (this.name) {
        if (this.name.trim().length > 200) {
          errors += 1;
          this.nameMsg = 'Name cannot exceed 200 characters.';
          this.hasErrorName = true;
        }
      }
      if (this.street1) {
        if (this.street1.trim().length > 100) {
          errors += 1;
          this.street1Msg = 'Street cannot exceed 100 characters.';
          this.hasErrorStreet1 = true;
        }
      }
      if (this.street2) {
        if (this.street2.trim().length > 100) {
          errors += 1;
          this.street2Msg = 'Street cannot exceed 100 characters.';
          this.hasErrorStreet2 = true;
        }
      }
      if (this.city) {
        if (this.city.trim().length > 40) {
          errors += 1;
          this.cityMsg = 'City cannot exceed 40 characters.';
          this.hasErrorCity = true;
        }
      }
      if (this.zip) {
        if (this.zip.trim().length > 10) {
          errors += 1;
          this.zipMsg = 'Zip cannot exceed 10 characters.';
          this.hasErrorZip = true;
        }
      }

      if (errors === 0) {
        this.search();
      }
    },
    resetErrors() {
      this.nameMsg = null;
      this.street1Msg = null;
      this.street2Msg = null;
      this.cityMsg = null;
      this.stateMsg = null;
      this.zipMsg = null;
      this.hasErrorName = false;
      this.hasErrofrStreet1 = false;
      this.hasErrorStreet2 = false;
      this.hasErrorCity = false;
      this.hasErrorState = false;
      this.hasErrorZip = false;
    },
    resetForm() {
      this.resetErrors();

      this.name = null;
      this.street1 = null;
      this.street2 = null;
      this.city = null;
      this.state = 'LA';
      this.zip = null;

      if (Object.entries(this.$route.query).length) {
        this.$router.push(
          {
            name: 'advancedSearch',
          },
        );
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 828px
    margin: auto
  .reset
    width: 30px
  li
    border-left: 0 !important
</style>
